import { useGetCrmIntegrations } from '@tinct/core-api';
import { useGetCurrentWorkspaceId } from '@tinct/core-workspace';

/**
 * Whether the workspace can use the `hubspot` lead-form destination: a READY
 * HubSpot integration must exist. `connectedAt` is surfaced so callers can
 * hint about pre-rollout connections that need a re-consent (the OAuth
 * scopes now include contact write).
 */
export function useHubspotReadiness() {
  const workspaceId = useGetCurrentWorkspaceId();

  const { data, isLoading } = useGetCrmIntegrations(
    {
      offset: 0,
      limit: 50,
      filters: { organizationId: workspaceId ?? '' },
    },
    { enabled: !!workspaceId },
  );

  const hubspot = (data?.data ?? []).find(
    (integration) => integration.providerType === 'hubspot',
  );

  return {
    isLoading,
    hubspotReady: hubspot?.status === 'ready',
    hubspotConnectedAt: hubspot?.connectedAt ?? null,
  };
}
